import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import UploadFile from '@/components/layout/uploadFile/UploadFile.vue'
import UploadLogotipo from '@/components/layout/uploadImagem/UploadLogotipo.vue'
import { mapActions } from 'vuex'
import util from '@/util'
import infra from '@/util/infra'
import arquivoUtil from '@/util/arquivoUtil'
import mensagens from '@/util/mensagens'
import { emitentesMixins } from '@/modules/emitentes/mixins'

export default {
  name: 'cadastro-emitente',

  components: {
    cabecalho,
    menuLateral,
    UploadFile,
    UploadLogotipo
  },

  mixins: [emitentesMixins],

  data () {
    return {
      logotipoBase64: null,
      logotipoRequisitado: false
    }
  },

  computed: {
    logotipoImagem () {
      return {
        codigoBase64: (!this.removerLogotipo ? this.logotipoBase64 : null),
        urlExterna: null
      }
    }
  },

  mounted () {
    this.ActionResetarDadosFormularioEmitente()

    const id = this.$route.params.id

    if (id) {
      this.obterEmitente(id)
    }
  },

  methods: {
    ...mapActions('emitentes', ['ActionObterEmitente', 'ActionResetarDadosFormularioEmitente']),

    async obterEmitente (id) {
      try {
        await this.ActionObterEmitente(id)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        console.error(e)
      }
    },

    /*
     * O preview é carregado só quando a aba do logotipo abre: o cropper mede o container no mount e,
     * dentro de uma aba escondida, essas medidas são zero e a imagem nunca aparece.
     */
    async abrirAbaLogotipo () {
      if (this.logotipoRequisitado) return

      this.logotipoRequisitado = true

      await this.obterLogotipo()
      await this.$nextTick()

      const upload = this.$refs.uploadLogotipoEmitente
      if (upload) upload.atualizarPreview()
    },

    /*
     * O endpoint do logotipo é protegido pela sessão. Passar a URL como src de imagem faria o
     * navegador buscá-la como recurso anônimo (sem o cookie da sessão) e receber 401, então o
     * download passa pelo axios do app e a imagem vai para o preview em base64.
     */
    async obterLogotipo () {
      this.logotipoBase64 = null

      const url = this.formulario.configuracoes.logotipo_url

      if (util.valorVazio(url)) return

      try {
        const resposta = await infra.downloadDeArquivoViaCloud(url)
        const arquivo = resposta?.data
        const tipo = arquivo?.type ?? ''

        if (!tipo.startsWith('image/')) {
          throw new Error('O logotipo do emitente não está disponível')
        }

        this.logotipoBase64 = await arquivoUtil.converterBlobParaBase64(arquivo)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaAoObterLogotipoEmitente)
        console.error(e)
      }
    }
  }
}
